import React, { useRef, useEffect } from "react";
import dmcLogo from "../assets/logos/dmc.png";
import tranquilityLogo from "../assets/logos/tranquility.png";
import touchOfLoveLogo from "../assets/logos/touch-of-love.png";
import habibiLogo from "../assets/logos/habibi.png";
import "./CompanyBanner.css";

const companies = [
  { name: "DMC Mining", logo: dmcLogo },
  { name: "Tranquility Distributors", logo: tranquilityLogo },
  { name: "Touch of Love Hair Salon", logo: touchOfLoveLogo },
  { name: "Habibi Events", logo: habibiLogo },
];

const CompanyBanner = () => {
  const trackRef = useRef(null);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    let startX = 0;
    const speed = 0.75; // Ultra-smooth creeping speed execution

    const animate = () => {
      if (!track) return;
      // Loop point maps to half of the double list implementation width
      const resetPoint = track.scrollWidth / 2;
      startX -= speed;

      if (Math.abs(startX) >= resetPoint) {
        startX = 0;
      }

      track.style.transform = `translateX(${startX}px)`;
      requestAnimationFrame(animate);
    };

    const animationId = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationId);
    };
  }, []);

  // Double array map creates a seamless, endless loop without gaps
  const dualCompaniesList = [...companies, ...companies];

  return (
    <div className="banner-section">
      <p className="banner-label">Trusted by Leading Brands</p>
      <div className="banner-viewport-mask">
        <div className="banner-track" ref={trackRef}>
          {dualCompaniesList.map((company, index) => (
            <div
              key={`${company.name}-${index}`}
              className="banner-logo-wrapper"
            >
              <img
                src={company.logo}
                alt={company.name}
                className="banner-logo"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CompanyBanner;
